import React from 'react'
import { Box, Typography, Button } from '@mui/material'

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo })
    console.error('Uncaught error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{p:4}}>
          <Typography variant='h4' color='error' gutterBottom>Unexpected Application Error</Typography>
          <Typography variant='body1' sx={{mb:2}}>An error occurred. See console for details.</Typography>
          <Box sx={{whiteSpace:'pre-wrap', background:'#f7f7f7', p:2, borderRadius:1, maxHeight:400, overflow:'auto'}}>
            {this.state.error && String(this.state.error)}
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </Box>
          <Button sx={{mt:2}} variant='contained' onClick={()=>window.location.reload()}>Reload</Button>
        </Box>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
